import {
  GET_PAYROLL_SALARY,
  GET_PAYROLL_SALARY_SUCCESS,
  GET_PAYROLL_SALARY_FAIL,
  DELETE_PAYROLL_SALARY,
  DELETE_PAYROLL_SALARY_SUCCESS,
  DELETE_PAYROLL_SALARY_FAIL,
  UPDATE_PAYROLL_SALARY,
  UPDATE_PAYROLL_SALARY_SUCCESS,
  UPDATE_PAYROLL_SALARY_FAIL,
  ADD_NEW_PAYROLL_SALARY,
  ADD_PAYROLL_SALARY_SUCCESS,
  ADD_PAYROLL_SALARY_FAIL,
  PAYROLL_SALARY_LOADING,
  PAYROLL_SALARY_RESET,
} from "./actionType";

export const resetPayrollSalaryState = (actionType) => ({
  type: PAYROLL_SALARY_RESET,
  payload: { actionType },
});

export const getPayrollSalarySuccess = (actionType, data) => ({
  type: GET_PAYROLL_SALARY_SUCCESS,
  payload: { actionType, data },
});

export const getPayrollSalaryFail = (actionType, error) => ({
  type: GET_PAYROLL_SALARY_FAIL,
  payload: { actionType, error },
});

export const getPayrollSalary = data => ({
  type: GET_PAYROLL_SALARY,
  payload: data,
});

export const getPayrollSalaryLoading = () => ({
  type: PAYROLL_SALARY_LOADING
});

export const deletePayrollSalary = data => ({
  type: DELETE_PAYROLL_SALARY,
  payload: data,
});

export const deletePayrollSalarySuccess = data => ({
  type: DELETE_PAYROLL_SALARY_SUCCESS,
  payload: data,
});

export const deletePayrollSalaryFail = error => ({
  type: DELETE_PAYROLL_SALARY_FAIL,
  payload: error,
});

export const updatePayrollSalary = data => ({
  type: UPDATE_PAYROLL_SALARY,
  payload: data,
});

export const updatePayrollSalaryFail = error => ({
  type: UPDATE_PAYROLL_SALARY_FAIL,
  payload: error,
});

export const updatePayrollSalarySuccess = data => ({
  type: UPDATE_PAYROLL_SALARY_SUCCESS,
  payload: data,
});

export const addNewPayrollSalary = data => ({
  type: ADD_NEW_PAYROLL_SALARY,
  payload: data,
});

export const addPayrollSalarySuccess = data => ({
  type: ADD_PAYROLL_SALARY_SUCCESS,
  payload: data,
});

export const addPayrollSalaryFail = error => ({
  type: ADD_PAYROLL_SALARY_FAIL,
  payload: error,
});